import { getCart, updateCart } from './cart-api.js';

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
      this.checkGiftConfig(this.dataset.productId);
    });
  }

  checkGiftConfig(deletedProductId) {
    const giftSettings = JSON.parse(window.giftSettings);

    // We need to check if the gift settings have any config for the element we're deleting, if not, we need to remove the gift manually
    if (!giftSettings?.length || !giftSettings.some(item => item.targetProductId === deletedProductId.toString())) {
      setTimeout(() => this.removeTrainingGift(deletedProductId), 500);
    }
  }

  async removeTrainingGift(deletedProductId) {
    const gwpRestrictionsCollection = window.gwpRestrictionsCollection || null;
    const trainingRestrictionsCollection = window.trainingRestrictionsCollection || null;
    let trainingGifts = [];
    let trainings = [];

    if (gwpRestrictionsCollection) {
      gwpRestrictionsCollection.map((product) => trainingGifts.push(product.id));
    }
    if (trainingRestrictionsCollection) {
      trainingRestrictionsCollection.map((product) => trainings.push(product.id));
    }

    if (!trainings.includes(parseInt(deletedProductId))) {
      return;
    }

    const cart = await getCart();
    const itemsToRemove = cart.items
       .filter((item) => trainingGifts.includes(item.product_id));

    const removalResponses = [];
    for (const item of itemsToRemove) {
      const response = await updateCart({
        id: item.key,
        quantity: 0,
        sections: this.getSectionsToRender().map((section) => section.id),
      });
      
      removalResponses.push(response);
    }
      
    removalResponses.forEach((response) => {
      this.reloadSections(response);
    });
  }

  reloadSections(parsedState) {
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    const cartFooter = document.getElementById('main-cart-footer');
    const cartItemsWrapper = document.querySelector('cart-items');
    const cartDrawerApp = document.querySelector("cart-drawer-app");

    if (cartFooter)
      cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
    if (cartDrawerWrapper)
      cartDrawerWrapper.classList.toggle(
        "is-empty",
        parsedState.item_count === 0
      );
    if (cartItemsWrapper)
      cartItemsWrapper.classList.toggle(
        "is-empty",
        parsedState.item_count === 0
      );
    if (cartDrawerApp)
      cartDrawerApp.classList.toggle("is-empty", parsedState.item_count === 0);

    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (sectionElement) {
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    const isCartPage = window.location.pathname === "/cart";
  
    return isCartPage
      ? [
          ...["main-cart-items", "main-cart-footer"].map((id) => ({
            id,
            section: document.getElementById(id)?.dataset.id,
            selector: `#${id}`,
          })),
          {
            id: "cart-icon-bubble",
            section: "cart-icon-bubble",
            selector: "#cart-icon-bubble",
          },
        ]
      : [
          { id: "cart-drawer", selector: "#CartDrawer" },
          { id: "cart-icon-bubble" },
          { id: "cart-drawer-app" },
        ];
  }
}

customElements.define('cart-remove-button', CartRemoveButton);